// // // // // components/admin/AdManagement.jsx
// // // // import React, { useState, useEffect } from "react";
// // // // import {
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableContainer,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   Button,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   TextField,
// // // //   MenuItem,
// // // //   Box,
// // // //   IconButton,
// // // //   Tooltip,
// // // //   Switch,
// // // //   FormControlLabel,
// // // //   Typography,
// // // // } from "@mui/material";
// // // // import {
// // // //   getAllAds,
// // // //   createAd,
// // // //   updateAd,
// // // //   deleteAd,
// // // // } from "../../../services/adminService"; // Make sure this path is correct
// // // // import CloseIcon from "@mui/icons-material/Close";
// // // // import EditIcon from '@mui/icons-material/Edit';
// // // // import DeleteIcon from '@mui/icons-material/Delete';
// // // // import ImageIcon from '@mui/icons-material/Image';
// // // // import VideocamIcon from '@mui/icons-material/Videocam';
// // // // import LinkIcon from '@mui/icons-material/Link';
// // // // import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// // // // import CancelIcon from '@mui/icons-material/Cancel';

// // // // const AdManagement = () => {
// // // //   const [ads, setAds] = useState([]);
// // // //   const [openDialog, setOpenDialog] = useState(false);
// // // //   const [editingAd, setEditingAd] = useState(null);
// // // //   const [formData, setFormData] = useState({
// // // //     type: "google", // 'google' or 'custom'
// // // //     position: "top", // 'top', 'bottom', 'sidebar', 'popup', 'inline'
// // // //     link: "", // Required for 'google' type, URL for AdSense script
// // // //     title: "", // Required for 'custom' type
// // // //     mediaType: null, // 'image', 'video', null for custom
// // // //     mediaFile: null, // For file uploads
// // // //     isActive: true, // Boolean
// // // //     clearMedia: false, // For explicitly clearing media on update
// // // //   });

// // // //   const adPositions = ['top', 'bottom', 'sidebar', 'popup', 'inline'];
// // // //   const adTypes = ['google', 'custom'];
// // // //   const customMediaTypes = ['image', 'video'];

// // // //   const fetchAds = async () => {
// // // //     try {
// // // //       const data = await getAllAds();
// // // //       setAds(data.ads);
// // // //     } catch (error) {
// // // //       console.error("Error fetching ads:", error);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchAds();
// // // //   }, []);

// // // //   const handleOpenDialog = (ad = null) => {
// // // //     setEditingAd(ad);
// // // //     if (ad) {
// // // //       setFormData({
// // // //         type: ad.type,
// // // //         position: ad.position,
// // // //         link: ad.type === 'google' ? ad.link : "",
// // // //         title: ad.type === 'custom' ? ad.title : "",
// // // //         mediaType: ad.type === 'custom' ? ad.mediaType : null,
// // // //         mediaFile: null, // Never pre-fill file input
// // // //         isActive: ad.isActive,
// // // //         clearMedia: false, // Reset clearMedia flag
// // // //       });
// // // //     } else {
// // // //       setFormData({
// // // //         type: "google",
// // // //         position: "top",
// // // //         link: "",
// // // //         title: "",
// // // //         mediaType: null,
// // // //         mediaFile: null,
// // // //         isActive: true,
// // // //         clearMedia: false,
// // // //       });
// // // //     }
// // // //     setOpenDialog(true);
// // // //   };

// // // //   const handleCloseDialog = () => {
// // // //     setOpenDialog(false);
// // // //     setEditingAd(null);
// // // //     setFormData({
// // // //       type: "google",
// // // //       position: "top",
// // // //       link: "",
// // // //       title: "",
// // // //       mediaType: null,
// // // //       mediaFile: null,
// // // //       isActive: true,
// // // //       clearMedia: false,
// // // //     });
// // // //   };

// // // //   const handleFormChange = (e) => {
// // // //     const { name, value, type, checked } = e.target;
// // // //     if (name === "type") {
// // // //       // Reset relevant fields when ad type changes
// // // //       setFormData(prev => ({
// // // //         ...prev,
// // // //         [name]: value,
// // // //         link: value === 'google' ? prev.link : '',
// // // //         title: value === 'custom' ? prev.title : '',
// // // //         mediaType: value === 'custom' ? prev.mediaType : null,
// // // //         mediaFile: null, // Clear file on type change
// // // //       }));
// // // //     } else if (type === "checkbox") {
// // // //       setFormData({ ...formData, [name]: checked });
// // // //     } else {
// // // //       setFormData({ ...formData, [name]: value });
// // // //     }
// // // //   };

// // // //   const handleFileChange = (e) => {
// // // //     setFormData({ ...formData, mediaFile: e.target.files[0] });
// // // //   };

// // // //   const handleSubmit = async () => {
// // // //     if (!formData.type || !formData.position) {
// // // //       alert("Please fill all required fields!");
// // // //       return;
// // // //     }

// // // //     if (formData.type === 'google' && !formData.link) {
// // // //       alert("Please provide Google AdSense script URL!");
// // // //       return;
// // // //     }

// // // //     if (formData.type === 'custom' && !formData.title) {
// // // //       alert("Please provide a title for the custom ad!");
// // // //       return;
// // // //     }

// // // //     // Custom ad without existing media or new file and not clearing existing media is an error
// // // //     if (formData.type === 'custom' && !formData.mediaFile && !editingAd?.mediaUrl && !formData.clearMedia) {
// // // //       alert("Please upload an image/video file for the custom ad or an existing media URL should be present!");
// // // //       return;
// // // //     }

// // // //     try {
// // // //       const data = new FormData();
// // // //       data.append("type", formData.type);
// // // //       data.append("position", formData.position);
// // // //       data.append("isActive", formData.isActive);

// // // //       if (formData.type === 'google') {
// // // //         data.append("link", formData.link);
// // // //       } else { // type === 'custom'
// // // //         data.append("title", formData.title);
// // // //         if (formData.mediaType) data.append("mediaType", formData.mediaType);

// // // //         if (formData.mediaFile) {
// // // //           data.append("media", formData.mediaFile); // changed from mediaFile to media
// // // //         } else if (formData.clearMedia && editingAd?.mediaUrl) {
// // // //           // Only send clearMedia=true if there was existing media to clear
// // // //           data.append("clearMedia", "true");
// // // //         }
// // // //       }

// // // //       if (editingAd) {
// // // //         await updateAd(editingAd._id, data);
// // // //       } else {
// // // //         await createAd(data);
// // // //       }

// // // //       fetchAds();
// // // //       handleCloseDialog();
// // // //     } catch (error) {
// // // //       console.error("Error saving ad:", error);
// // // //       alert("Error occurred while saving ad: " + (error.response?.data?.message || error.message));
// // // //     }
// // // //   };

// // // //   const handleDelete = async (id) => {
// // // //     if (window.confirm("Are you sure you want to delete this ad?")) {
// // // //       try {
// // // //         await deleteAd(id);
// // // //         fetchAds();
// // // //       } catch (error) {
// // // //         console.error("Error deleting ad:", error);
// // // //         alert("Error occurred while deleting ad: " + (error.response?.data?.message || error.message));
// // // //       }
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Paper style={{ padding: "1rem" }}>
// // // //       <Typography variant="h5" component="h2" gutterBottom>Ad Management</Typography>
// // // //       <Button variant="contained" color="primary" onClick={() => handleOpenDialog()} style={{ marginBottom: "1rem" }}>
// // // //         Add New Ad
// // // //       </Button>

// // // //       <TableContainer>
// // // //         <Table>
// // // //           <TableHead>
// // // //             <TableRow>
// // // //               <TableCell>#</TableCell>
// // // //               <TableCell>Type</TableCell>
// // // //               <TableCell>Position</TableCell>
// // // //               <TableCell>Title/Link</TableCell>
// // // //               <TableCell>Media</TableCell>
// // // //               <TableCell>Active</TableCell>
// // // //               <TableCell>Actions</TableCell>
// // // //             </TableRow>
// // // //           </TableHead>
// // // //           <TableBody>
// // // //             {ads.map((ad, idx) => (
// // // //               <TableRow key={ad._id}>
// // // //                 <TableCell>{idx + 1}</TableCell>
// // // //                 <TableCell>{ad.type === 'google' ? 'Google AdSense' : 'Custom'}</TableCell>
// // // //                 <TableCell>{ad.position}</TableCell>
// // // //                 <TableCell>
// // // //                   {ad.type === 'google' && (
// // // //                     <Tooltip title={ad.link}>
// // // //                       <LinkIcon color="action" />
// // // //                     </Tooltip>
// // // //                   )}
// // // //                   {ad.type === 'custom' && ad.title}
// // // //                 </TableCell>
// // // //                 <TableCell>
// // // //                   {ad.type === 'custom' && ad.mediaUrl && (
// // // //                     ad.mediaType === 'image' ? (
// // // //                       <img src={ad.mediaUrl} alt={ad.title} style={{ width: "80px", height: "auto", borderRadius: "4px" }} />
// // // //                     ) : (
// // // //                       <video src={ad.mediaUrl} width="80" height="auto" controls muted />
// // // //                     )
// // // //                   )}
// // // //                   {ad.type === 'custom' && !ad.mediaUrl && 'No Media'}
// // // //                 </TableCell>
// // // //                 <TableCell>
// // // //                   {ad.isActive ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
// // // //                 </TableCell>
// // // //                 <TableCell>
// // // //                   <Box display="flex" gap={1}>
// // // //                     <Tooltip title="Edit">
// // // //                       <IconButton color="primary" onClick={() => handleOpenDialog(ad)} size="small">
// // // //                         <EditIcon fontSize="small" />
// // // //                       </IconButton>
// // // //                     </Tooltip>
// // // //                     <Tooltip title="Delete">
// // // //                       <IconButton color="error" onClick={() => handleDelete(ad._id)} size="small">
// // // //                         <DeleteIcon fontSize="small" />
// // // //                       </IconButton>
// // // //                     </Tooltip>
// // // //                   </Box>
// // // //                 </TableCell>
// // // //               </TableRow>
// // // //             ))}
// // // //           </TableBody>
// // // //         </Table>
// // // //       </TableContainer>

// // // //       {/* Ad Form Dialog */}
// // // //       <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
// // // //         <DialogTitle>
// // // //           {editingAd ? "Edit Ad" : "Add New Ad"}
// // // //           <IconButton
// // // //             aria-label="close"
// // // //             onClick={handleCloseDialog}
// // // //             sx={{ position: 'absolute', right: 8, top: 8 }}
// // // //           >
// // // //             <CloseIcon />
// // // //           </IconButton>
// // // //         </DialogTitle>
// // // //         <DialogContent dividers>
// // // //           {/* Ad Type */}
// // // //           <TextField
// // // //             label="Ad Type"
// // // //             name="type"
// // // //             select
// // // //             fullWidth
// // // //             margin="dense"
// // // //             value={formData.type}
// // // //             onChange={handleFormChange}
// // // //             required
// // // //           >
// // // //             {adTypes.map((type) => (
// // // //               <MenuItem key={type} value={type}>
// // // //                 {type === 'google' ? 'Google AdSense' : 'Custom Ad'}
// // // //               </MenuItem>
// // // //             ))}
// // // //           </TextField>

// // // //           {/* Ad Position */}
// // // //           <TextField
// // // //             label="Ad Position"
// // // //             name="position"
// // // //             select
// // // //             fullWidth
// // // //             margin="dense"
// // // //             value={formData.position}
// // // //             onChange={handleFormChange}
// // // //             required
// // // //           >
// // // //             {adPositions.map((position) => (
// // // //               <MenuItem key={position} value={position}>{position}</MenuItem>
// // // //             ))}
// // // //           </TextField>

// // // //           {/* Google AdSense Link */}
// // // //           {formData.type === 'google' && (
// // // //             <TextField
// // // //               label="Google AdSense Script URL"
// // // //               name="link"
// // // //               fullWidth
// // // //               margin="dense"
// // // //               value={formData.link}
// // // //               onChange={handleFormChange}
// // // //               required={formData.type === 'google'}
// // // //               helperText="This is the Google AdSense script URL (e.g., data-ad-client or data-ad-slot)"
// // // //             />
// // // //           )}

// // // //           {/* Custom Ad Fields */}
// // // //           {formData.type === 'custom' && (
// // // //             <Box mt={2}>
// // // //               <TextField
// // // //                 label="Ad Title"
// // // //                 name="title"
// // // //                 fullWidth
// // // //                 margin="dense"
// // // //                 value={formData.title}
// // // //                 onChange={handleFormChange}
// // // //                 required={formData.type === 'custom'}
// // // //               />

// // // //               {/* Media Type for Custom Ad */}
// // // //               <TextField
// // // //                 label="Media Type"
// // // //                 name="mediaType"
// // // //                 select
// // // //                 fullWidth
// // // //                 margin="dense"
// // // //                 value={formData.mediaType}
// // // //                 onChange={handleFormChange}
// // // //               >
// // // //                 <MenuItem value={null}>None (Title Only)</MenuItem>
// // // //                 {customMediaTypes.map((type) => (
// // // //                   <MenuItem key={type} value={type}>{type === 'image' ? 'Image' : 'Video'}</MenuItem>
// // // //                 ))}
// // // //               </TextField>

// // // //               {/* Media File Upload */}
// // // //               {(formData.mediaType === 'image' || formData.mediaType === 'video') && (
// // // //                 <Box mt={2} mb={2}>
// // // //                   <input
// // // //                     type="file"
// // // //                     accept={formData.mediaType === 'image' ? "image/*" : "video/*"}
// // // //                     onChange={handleFileChange}
// // // //                     style={{ display: 'block', marginBottom: '10px' }}
// // // //                   />
// // // //                   {(editingAd?.mediaUrl && !formData.mediaFile) && (
// // // //                     <Box display="flex" alignItems="center" mt={1}>
// // // //                       <Typography variant="body2" mr={1}>
// // // //                         Existing Media:
// // // //                         {editingAd.mediaType === 'image' && <ImageIcon color="action" />}
// // // //                         {editingAd.mediaType === 'video' && <VideocamIcon color="action" />}
// // // //                       </Typography>
// // // //                       <FormControlLabel
// // // //                         control={
// // // //                           <Switch
// // // //                             checked={formData.clearMedia}
// // // //                             onChange={handleFormChange}
// // // //                             name="clearMedia"
// // // //                             color="secondary"
// // // //                           />
// // // //                         }
// // // //                         label="Remove Existing Media"
// // // //                       />
// // // //                     </Box>
// // // //                   )}
// // // //                   {formData.mediaFile && <Typography variant="caption">Selected File: {formData.mediaFile.name}</Typography>}
// // // //                 </Box>
// // // //               )}
// // // //             </Box>
// // // //           )}

// // // //           {/* Is Active Switch */}
// // // //           <FormControlLabel
// // // //             control={
// // // //               <Switch
// // // //                 checked={formData.isActive}
// // // //                 onChange={handleFormChange}
// // // //                 name="isActive"
// // // //                 color="primary"
// // // //               />
// // // //             }
// // // //             label="Ad is Active"
// // // //             style={{ marginTop: "1rem" }}
// // // //           />
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={handleCloseDialog} color="secondary">
// // // //             Cancel
// // // //           </Button>
// // // //           <Button onClick={handleSubmit} variant="contained" color="primary">
// // // //             {editingAd ? "Update" : "Create"}
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //     </Paper>
// // // //   );
// // // // };

// // // // export default AdManagement;


// // // // components/admin/AdManagement.jsx
// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   Button,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   TextField,
// // //   MenuItem,
// // //   Box,
// // //   IconButton,
// // //   Tooltip,
// // //   Switch,
// // //   FormControlLabel,
// // //   Typography,
// // // } from "@mui/material";
// // // import {
// // //   getAllAds,
// // //   createAd,
// // //   updateAd,
// // //   deleteAd,
// // // } from "../../../services/adminService"; // Make sure this path is correct
// // // import CloseIcon from "@mui/icons-material/Close";
// // // import EditIcon from "@mui/icons-material/Edit";
// // // import DeleteIcon from "@mui/icons-material/Delete";
// // // import ImageIcon from "@mui/icons-material/Image";
// // // import VideocamIcon from "@mui/icons-material/Videocam";
// // // import LinkIcon from "@mui/icons-material/Link";
// // // import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// // // import CancelIcon from "@mui/icons-material/Cancel";

// // // const AdManagement = () => {
// // //   const [ads, setAds] = useState([]);
// // //   const [openDialog, setOpenDialog] = useState(false);
// // //   const [editingAd, setEditingAd] = useState(null);
// // //   const [formData, setFormData] = useState({
// // //     type: "google", // 'google' or 'custom'
// // //     position: "top", // 'top', 'bottom', 'sidebar', 'popup', 'inline'
// // //     link: "", // Required for 'google' type
// // //     title: "", // Required for 'custom' type
// // //     mediaType: null, // 'image', 'video', 'gif'
// // //     mediaFile: null, // For file uploads
// // //     isActive: true, // Boolean
// // //     clearMedia: false, // For explicitly clearing media on update
// // //   });



// // //   const adPositions = ["top", "bottom", "sidebar", "popup", "inline"];
// // //   const adTypes = ["google", "custom"];
// // //   const customMediaTypes = ["image", "video", "gif"];

// // //   const fetchAds = async () => {
// // //     try {
// // //       const data = await getAllAds();
// // //       setAds(data.ads);
// // //     } catch (error) {
// // //       console.error("Error fetching ads:", error);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchAds();
// // //   }, []);

// // //   const handleOpenDialog = (ad = null) => {
// // //     setEditingAd(ad);
// // //     if (ad) {
// // //       setFormData({
// // //         type: ad.type,
// // //         position: ad.position,
// // //         link: ad.type === "google" ? ad.link : "",
// // //         title: ad.type === "custom" ? ad.title : "",
// // //         mediaType: ad.type === "custom" ? ad.mediaType : null,
// // //         mediaFile: null,
// // //         isActive: ad.isActive,
// // //         clearMedia: false,
// // //       });
// // //     } else {
// // //       setFormData({
// // //         type: "google",
// // //         position: "top",
// // //         link: "",
// // //         title: "",
// // //         mediaType: null,
// // //         mediaFile: null,
// // //         isActive: true,
// // //         clearMedia: false,
// // //       });
// // //     }
// // //     setOpenDialog(true);
// // //   };

// // //   const handleCloseDialog = () => {
// // //     setOpenDialog(false);
// // //     setEditingAd(null);
// // //     setFormData({
// // //       type: "google",
// // //       position: "top",
// // //       link: "",
// // //       title: "",
// // //       mediaType: null,
// // //       mediaFile: null,
// // //       isActive: true,
// // //       clearMedia: false,
// // //     });
// // //   };

// // //   const handleFormChange = (e) => {
// // //     const { name, value, type, checked } = e.target;
// // //     if (name === "type") {
// // //       setFormData((prev) => ({
// // //         ...prev,
// // //         [name]: value,
// // //         link: value === "google" ? prev.link : "",
// // //         title: value === "custom" ? prev.title : "",
// // //         mediaType: value === "custom" ? prev.mediaType : null,
// // //         mediaFile: null,
// // //       }));
// // //     } else if (type === "checkbox") {
// // //       setFormData({ ...formData, [name]: checked });
// // //     } else {
// // //       setFormData({ ...formData, [name]: value });
// // //     }
// // //   };

// // //   const handleFileChange = (e) => {
// // //     setFormData({ ...formData, mediaFile: e.target.files[0] });
// // //   };

// // //   const handleSubmit = async () => {
// // //     if (!formData.type || !formData.position) {
// // //       alert("Please fill all required fields!");
// // //       return;
// // //     }

// // //     if (formData.type === "google" && !formData.link) {
// // //       alert("Please provide Google AdSense script URL!");
// // //       return;
// // //     }

// // //     if (formData.type === "custom" && !formData.title) {
// // //       alert("Please provide a title for the custom ad!");
// // //       return;
// // //     }

// // //     if (
// // //       formData.type === "custom" &&
// // //       !formData.mediaFile &&
// // //       !editingAd?.mediaUrl &&
// // //       !formData.clearMedia
// // //     ) {
// // //       alert(
// // //         "Please upload an image/video/GIF file for the custom ad or an existing media URL should be present!"
// // //       );
// // //       return;
// // //     }

// // //     try {
// // //       const data = new FormData();
// // //       data.append("type", formData.type);
// // //       data.append("position", formData.position);
// // //       data.append("isActive", formData.isActive);

// // //       if (formData.type === "google") {
// // //         data.append("link", formData.link);
// // //       } else {
// // //         data.append("title", formData.title);
// // //         if (formData.mediaType) data.append("mediaType", formData.mediaType);

// // //         if (formData.mediaFile) {
// // //           data.append("media", formData.mediaFile);
// // //         } else if (formData.clearMedia && editingAd?.mediaUrl) {
// // //           data.append("clearMedia", "true");
// // //         }
// // //       }

// // //       if (editingAd) {
// // //         await updateAd(editingAd._id, data);
// // //       } else {
// // //         await createAd(data);
// // //       }

// // //       fetchAds();
// // //       handleCloseDialog();
// // //     } catch (error) {
// // //       console.error("Error saving ad:", error);
// // //       alert(
// // //         "Error occurred while saving ad: " +
// // //           (error.response?.data?.message || error.message)
// // //       );
// // //     }
// // //   };

// // //   const handleDelete = async (id) => {
// // //     if (window.confirm("Are you sure you want to delete this ad?")) {
// // //       try {
// // //         await deleteAd(id);
// // //         fetchAds();
// // //       } catch (error) {
// // //         console.error("Error deleting ad:", error);
// // //         alert(
// // //           "Error occurred while deleting ad: " +
// // //             (error.response?.data?.message || error.message)
// // //         );
// // //       }
// // //     }
// // //   };

// // //   const AD_SIZE_HINTS = {
// // //   top: "970 × 250 px",
// // //   sidebar: "300 × 250 px",
// // //   bottom: "728 × 90 px",
// // //   popup: "336 × 280 px",
// // //   inline: "(370 × 370 px ) / (250 × 215 px)",
// // // };


// // //   return (
// // //     <Paper style={{ padding: "1rem" }}>
// // //       <Typography variant="h5" component="h2" gutterBottom>
// // //         Ad Management
// // //       </Typography>
// // //       <Button
// // //         variant="contained"
// // //         color="primary"
// // //         onClick={() => handleOpenDialog()}
// // //         style={{ marginBottom: "1rem" }}
// // //       >
// // //         Add New Ad
// // //       </Button>

// // //       <TableContainer>
// // //         <Table>
// // //           <TableHead>
// // //             <TableRow>
// // //               <TableCell>#</TableCell>
// // //               <TableCell>Type</TableCell>
// // //               <TableCell>Position</TableCell>
// // //               <TableCell>Title/Link</TableCell>
// // //               <TableCell>Media</TableCell>
// // //               <TableCell>Active</TableCell>
// // //               <TableCell>Actions</TableCell>
// // //             </TableRow>
// // //           </TableHead>
// // //           <TableBody>
// // //             {ads.map((ad, idx) => (
// // //               <TableRow key={ad._id}>
// // //                 <TableCell>{idx + 1}</TableCell>
// // //                 <TableCell>
// // //                   {ad.type === "google" ? "Google AdSense" : "Custom"}
// // //                 </TableCell>
// // //                 <TableCell>{ad.position}</TableCell>
// // //                 <TableCell>
// // //                   {ad.type === "google" && (
// // //                     <Tooltip title={ad.link}>
// // //                       <LinkIcon color="action" />
// // //                     </Tooltip>
// // //                   )}
// // //                   {ad.type === "custom" && ad.title}
// // //                 </TableCell>
// // //                 <TableCell>
// // //                   {ad.type === "custom" && ad.mediaUrl ? (
// // //                     ad.mediaType === "video" ? (
// // //                       <video
// // //                         src={ad.mediaUrl}
// // //                         width="80"
// // //                         height="auto"
// // //                         controls
// // //                         muted
// // //                       />
// // //                     ) : (
// // //                       <img
// // //                         src={ad.mediaUrl}
// // //                         alt={ad.title}
// // //                         style={{
// // //                           width: "80px",
// // //                           height: "auto",
// // //                           borderRadius: "4px",
// // //                         }}
// // //                       />
// // //                     )
// // //                   ) : (
// // //                     "No Media"
// // //                   )}
// // //                 </TableCell>
// // //                 <TableCell>
// // //                   {ad.isActive ? (
// // //                     <CheckCircleIcon color="success" />
// // //                   ) : (
// // //                     <CancelIcon color="error" />
// // //                   )}
// // //                 </TableCell>
// // //                 <TableCell>
// // //                   <Box display="flex" gap={1}>
// // //                     <Tooltip title="Edit">
// // //                       <IconButton
// // //                         color="primary"
// // //                         onClick={() => handleOpenDialog(ad)}
// // //                         size="small"
// // //                       >
// // //                         <EditIcon fontSize="small" />
// // //                       </IconButton>
// // //                     </Tooltip>
// // //                     <Tooltip title="Delete">
// // //                       <IconButton
// // //                         color="error"
// // //                         onClick={() => handleDelete(ad._id)}
// // //                         size="small"
// // //                       >
// // //                         <DeleteIcon fontSize="small" />
// // //                       </IconButton>
// // //                     </Tooltip>
// // //                   </Box>
// // //                 </TableCell>
// // //               </TableRow>
// // //             ))}
// // //           </TableBody>
// // //         </Table>
// // //       </TableContainer>

// // //       {/* Dialog Form */}
// // //       <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
// // //         <DialogTitle>
// // //           {editingAd ? "Edit Ad" : "Add New Ad"}
// // //           <IconButton
// // //             aria-label="close"
// // //             onClick={handleCloseDialog}
// // //             sx={{ position: "absolute", right: 8, top: 8 }}
// // //           >
// // //             <CloseIcon />
// // //           </IconButton>
// // //         </DialogTitle>
// // //         <DialogContent dividers>
// // //           {/* Ad Type */}
// // //           <TextField
// // //             label="Ad Type"
// // //             name="type"
// // //             select
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.type}
// // //             onChange={handleFormChange}
// // //             required
// // //           >
// // //             {adTypes.map((type) => (
// // //               <MenuItem key={type} value={type}>
// // //                 {type === "google" ? "Google AdSense" : "Custom Ad"}
// // //               </MenuItem>
// // //             ))}
// // //           </TextField>

// // //           {/* Ad Position */}
// // //           <TextField
// // //             label="Ad Position"
// // //             name="position"
// // //             select
// // //             fullWidth
// // //             margin="dense"
// // //             value={formData.position}
// // //             onChange={handleFormChange}
// // //             required
// // //           >
// // //             {adPositions.map((position) => (
// // //               <MenuItem key={position} value={position}>
// // //                 {position}
// // //               </MenuItem>
// // //             ))}
// // //           </TextField>

// // //           {/* Google Link */}
// // //           {formData.type === "google" && (
// // //             <TextField
// // //               label="Google AdSense Script URL"
// // //               name="link"
// // //               fullWidth
// // //               margin="dense"
// // //               value={formData.link}
// // //               onChange={handleFormChange}
// // //               required
// // //               helperText="This is the Google AdSense script URL"
// // //             />
// // //           )}

// // //           {/* Custom Ad */}
// // //           {formData.type === "custom" && (
// // //             <Box mt={2}>
// // //               <TextField
// // //                 label="Ad Title"
// // //                 name="title"
// // //                 fullWidth
// // //                 margin="dense"
// // //                 value={formData.title}
// // //                 onChange={handleFormChange}
// // //                 required
// // //               />
// // //               <Box mb={1} mt={2}>
// // //   <strong style={{ color: "#2f91d3ff", fontSize: "14px" }}>
// // //     ⚠️ Only files up to 1 MB are allowed (Image / Video / GIF)
// // //   </strong>
// // // </Box>

// // //               {/* Media Type */}
// // //               <TextField
// // //                 label="Media Type"
// // //                 name="mediaType"
// // //                 select
// // //                 fullWidth
// // //                 margin="dense"
// // //                 value={formData.mediaType}
// // //                 onChange={handleFormChange}
// // //               >
// // //                 <MenuItem value={null}>None (Title Only)</MenuItem>
// // //                 {customMediaTypes.map((type) => (
// // //                   <MenuItem key={type} value={type}>
// // //                     {type === "image"
// // //                       ? "Image"
// // //                       : type === "video"
// // //                       ? "Video"
// // //                       : "GIF"}
// // //                   </MenuItem>
// // //                 ))}
// // //               </TextField>

// // //               {/* File Upload */}
// // //               {(formData.mediaType === "image" ||
// // //                 formData.mediaType === "video" ||
// // //                 formData.mediaType === "gif") && (
// // //                 <Box mt={2} mb={2}>
// // //                   <input
// // //                     type="file"
// // //                     accept={
// // //                       formData.mediaType === "image"
// // //                         ? "image/*"
// // //                         : formData.mediaType === "video"
// // //                         ? "video/*"
// // //                         : "image/gif"
// // //                     }
// // //                     onChange={handleFileChange}
// // //                     style={{ display: "block", marginBottom: "10px" }}
// // //                   />
// // //                   {editingAd?.mediaUrl && !formData.mediaFile && (
// // //                     <Box display="flex" alignItems="center" mt={1}>
// // //                       <Typography variant="body2" mr={1}>
// // //                         Existing Media:
// // //                         {editingAd.mediaType === "image" && (
// // //                           <ImageIcon color="action" />
// // //                         )}
// // //                         {editingAd.mediaType === "video" && (
// // //                           <VideocamIcon color="action" />
// // //                         )}
// // //                       </Typography>
// // //                       <FormControlLabel
// // //                         control={
// // //                           <Switch
// // //                             checked={formData.clearMedia}
// // //                             onChange={handleFormChange}
// // //                             name="clearMedia"
// // //                             color="secondary"
// // //                           />
// // //                         }
// // //                         label="Remove Existing Media"
// // //                       />
// // //                     </Box>
// // //                   )}
// // //                   {AD_SIZE_HINTS[formData.position] && (
// // //   <Box mb={1}>
// // //     <Typography
// // //       variant="caption"
// // //       sx={{ color: "#d21938ff", fontWeight: 600 }}
// // //     >
// // //       Recommended Size: {AD_SIZE_HINTS[formData.position]}
// // //     </Typography>
// // //   </Box>
// // // )}

// // //                   {formData.mediaFile && (
// // //                     <Typography variant="caption">
// // //                       Selected File: {formData.mediaFile.name}
// // //                     </Typography>
// // //                   )}
// // //                 </Box>
// // //               )}
// // //             </Box>
// // //           )}

// // //           {/* Active Switch */}
// // //           <FormControlLabel
// // //             control={
// // //               <Switch
// // //                 checked={formData.isActive}
// // //                 onChange={handleFormChange}
// // //                 name="isActive"
// // //                 color="primary"
// // //               />
// // //             }
// // //             label="Ad is Active"
// // //             style={{ marginTop: "1rem" }}
// // //           />
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleCloseDialog} color="secondary">
// // //             Cancel
// // //           </Button>
// // //           <Button onClick={handleSubmit} variant="contained" color="primary">
// // //             {editingAd ? "Update" : "Create"}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Paper>
// // //   );
// // // };

// // // export default AdManagement;
  
// // // components/admin/AdManagement.jsx

// // import React, { useState, useEffect } from "react";
// // import {
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   Button,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   MenuItem,
// //   Box,
// //   IconButton,
// //   Tooltip,
// //   Switch,
// //   FormControlLabel,
// //   Typography,
// // } from "@mui/material";

// // import {
// //   getAllAds,
// //   createAd,
// //   updateAd,
// //   deleteAd,
  
// // } from "../../../services/adminService";

// // import CloseIcon from "@mui/icons-material/Close";
// // import EditIcon from "@mui/icons-material/Edit";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import ImageIcon from "@mui/icons-material/Image";
// // import VideocamIcon from "@mui/icons-material/Videocam";
// // import LinkIcon from "@mui/icons-material/Link";
// // import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// // import CancelIcon from "@mui/icons-material/Cancel";

// // const AdManagement = () => {
// //   const [ads, setAds] = useState([]);
// //   const [openDialog, setOpenDialog] = useState(false);
// //   const [editingAd, setEditingAd] = useState(null);

// //   // 🔥 FORM STATE
// //   const [formData, setFormData] = useState({
// //     type: "google",
// //     position: "top",
// //     link: "",
// //     title: "",
// //     mediaType: null,
// //     mediaFile: null,
// //     isActive: true,
// //     clearMedia: false,

// //     // ✅ MULTI CATEGORY
// //     categories: ["home"],
// //   });

// //   const adPositions = ["top", "bottom", "sidebar", "popup", "inline", "inline2" , "inlineLarge"];
// //   const adTypes = ["google", "custom"];
// //   const customMediaTypes = ["image", "video", "gif"];

// //   // ✅ PAGE CATEGORIES
// //   const adCategories = [
// //     "home",
// //     "India",
// //     "state",
// //     "entertainment",
// //     "news",
// //     "sports",
// //     "business",
// //     "aadhaar",
// //     "scheme",
// //     "article",
// //     "Youth",


// //   ];

// //   const AD_SIZE_HINTS = {
// //     top: "970 × 250 px",
// //     sidebar: "300 × 250 px",
// //     bottom: "728 × 90 px",
// //     popup: "336 × 280 px",
// //     inline:  "728 × 90 px",
// //     inline2:  "728 × 90 px",
// //     inlineLarge:  "970 × 250 px",
// //   };

// //   const fetchAds = async () => {
// //     const data = await getAllAds();
// //     setAds(data.ads);
// //   };

// //   useEffect(() => {
// //     fetchAds();
// //   }, []);

// //   // 🔥 OPEN DIALOG
// //   const handleOpenDialog = (ad = null) => {
// //     setEditingAd(ad);

// //     if (ad) {
// //       setFormData({
// //         type: ad.type,
// //         position: ad.position,
// //         link: ad.type === "google" ? ad.link : "",
// //         title: ad.type === "custom" ? ad.title : "",
// //         mediaType: ad.type === "custom" ? ad.mediaType : null,
// //         mediaFile: null,
// //         isActive: ad.isActive,
// //         clearMedia: false,
// //         categories: ad.categories || ["home"],
// //       });
// //     } else {
// //       setFormData({
// //         type: "google",
// //         position: "top",
// //         link: "",
// //         title: "",
// //         mediaType: null,
// //         mediaFile: null,
// //         isActive: true,
// //         clearMedia: false,
// //         categories: ["home"],
// //       });
// //     }

// //     setOpenDialog(true);
// //   };

// //   const handleCloseDialog = () => {
// //     setOpenDialog(false);
// //     setEditingAd(null);
// //   };

// //   // 🔁 FORM CHANGE
// //   const handleFormChange = (e) => {
// //     const { name, value, type, checked } = e.target;

// //     if (type === "checkbox") {
// //       setFormData({ ...formData, [name]: checked });
// //     } else {
// //       setFormData({ ...formData, [name]: value });
// //     }
// //   };

// //   const handleFileChange = (e) => {
// //     setFormData({ ...formData, mediaFile: e.target.files[0] });
// //   };

// //   // 🚀 SUBMIT
// //   const handleSubmit = async () => {
// //     const data = new FormData();

// //     data.append("type", formData.type);
// //     data.append("position", formData.position);
// //     data.append("isActive", formData.isActive);

// //     // 🔥 MULTI CATEGORY SEND
// //     formData.categories.forEach((cat) => {
// //       data.append("categories[]", cat);
// //     });

// //     if (formData.type === "google") {
// //       data.append("link", formData.link);
// //     } else {
// //       data.append("title", formData.title);
// //       if (formData.mediaType) data.append("mediaType", formData.mediaType);
// //       if (formData.mediaFile) data.append("media", formData.mediaFile);
// //       if (formData.clearMedia) data.append("clearMedia", "true");
// //     }

// //     if (editingAd) {
// //       await updateAd(editingAd._id, data);
// //     } else {
// //       await createAd(data);
// //     }

// //     fetchAds();
// //     handleCloseDialog();
// //   };

// //   const handleDelete = async (id) => {
// //     if (window.confirm("Delete this ad?")) {
// //       await deleteAd(id);
// //       fetchAds();
// //     }
// //   };

// //   return (
// //     <Paper sx={{ p: 2 }}>
// //       <Typography variant="h5" gutterBottom>
// //         Ad Management
// //       </Typography>

// //       <Button variant="contained" onClick={() => handleOpenDialog()}>
// //         Add New Ad
// //       </Button>

// //       {/* TABLE */}
// //       <TableContainer sx={{ mt: 2 }}>
// //         <Table>
// //           <TableHead>
// //             <TableRow>
// //               <TableCell>#</TableCell>
// //               <TableCell>Type</TableCell>
// //               <TableCell>Position</TableCell>
// //               <TableCell>Categories</TableCell>
// //               <TableCell>Media</TableCell>
// //               <TableCell>Status</TableCell>
// //               <TableCell>Action</TableCell>
// //             </TableRow>
// //           </TableHead>

// //           <TableBody>
// //             {ads.map((ad, i) => (
// //               <TableRow key={ad._id}>
// //                 <TableCell>{i + 1}</TableCell>
// //                 <TableCell>{ad.type}</TableCell>
// //                 <TableCell>{ad.position}</TableCell>
// //                 <TableCell>{ad.categories?.join(", ")}</TableCell>
// //                 <TableCell>
// //                   {ad.mediaUrl ? (
// //                     ad.mediaType === "video" ? (
// //                       <video src={ad.mediaUrl} width="60" />
// //                     ) : (
// //                       <img src={ad.mediaUrl} width="60" />
// //                     )
// //                   ) : (
// //                     "—"
// //                   )}
// //                 </TableCell>
// //                 <TableCell>
// //                   {ad.isActive ? (
// //                     <CheckCircleIcon color="success" />
// //                   ) : (
// //                     <CancelIcon color="error" />
// //                   )}
// //                 </TableCell>
// //                 <TableCell>
// //                   <IconButton onClick={() => handleOpenDialog(ad)}>
// //                     <EditIcon />
// //                   </IconButton>
// //                   <IconButton color="error" onClick={() => handleDelete(ad._id)}>
// //                     <DeleteIcon />
// //                   </IconButton>
// //                 </TableCell>
// //               </TableRow>
// //             ))}
// //           </TableBody>
// //         </Table>
// //       </TableContainer>

// //       {/* DIALOG */}
// //       <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
// //         <DialogTitle>
// //           {editingAd ? "Edit Ad" : "Add Ad"}
// //           <IconButton
// //             onClick={handleCloseDialog}
// //             sx={{ position: "absolute", right: 8, top: 8 }}
// //           >
// //             <CloseIcon />
// //           </IconButton>
// //         </DialogTitle>

// //         <DialogContent dividers>
// //           <TextField
// //             label="Ad Type"
// //             name="type"
// //             select
// //             fullWidth
// //             margin="dense"
// //             value={formData.type}
// //             onChange={handleFormChange}
// //           >
// //             {adTypes.map((t) => (
// //               <MenuItem key={t} value={t}>
// //                 {t}
// //               </MenuItem>
// //             ))}
// //           </TextField>

// //           <TextField
// //             label="Position"
// //             name="position"
// //             select
// //             fullWidth
// //             margin="dense"
// //             value={formData.position}
// //             onChange={handleFormChange}
// //           >
// //             {adPositions.map((p) => (
// //               <MenuItem key={p} value={p}>
// //                 {p}
// //               </MenuItem>
// //             ))}
// //           </TextField>

// //           {/* 🔥 MULTI CATEGORY */}
// //           <TextField
// //             label="Select Pages"
// //             name="categories"
// //             select
// //             fullWidth
// //             margin="dense"
// //             SelectProps={{ multiple: true }}
// //             value={formData.categories}
// //             onChange={(e) =>
// //               setFormData({ ...formData, categories: e.target.value })
// //             }
// //           >
// //             {adCategories.map((c) => (
// //               <MenuItem key={c} value={c}>
// //                 {c.toUpperCase()}
// //               </MenuItem>
// //             ))}
// //           </TextField>

// //           {formData.type === "google" && (
// //             <TextField
// //               label="Google Ad Script"
// //               name="link"
// //               fullWidth
// //               margin="dense"
// //               value={formData.link}
// //               onChange={handleFormChange}
// //             />
// //           )}

// //           {formData.type === "custom" && (
// //             <>
// //               <TextField
// //                 label="Title"
// //                 name="title"
// //                 fullWidth
// //                 margin="dense"
// //                 value={formData.title}
// //                 onChange={handleFormChange}
// //               />

// //               <TextField
// //                 label="Media Type"
// //                 name="mediaType"
// //                 select
// //                 fullWidth
// //                 margin="dense"
// //                 value={formData.mediaType}
// //                 onChange={handleFormChange}
// //               >
// //                 {customMediaTypes.map((m) => (
// //                   <MenuItem key={m} value={m}>
// //                     {m}
// //                   </MenuItem>
// //                 ))}
// //               </TextField>

// //               <input type="file" onChange={handleFileChange} />

// //               {AD_SIZE_HINTS[formData.position] && (
// //                 <Typography variant="caption" color="error">
// //                   Recommended Size: {AD_SIZE_HINTS[formData.position]}
// //                 </Typography>
// //               )}
// //             </>
// //           )}

// //           <FormControlLabel
// //             control={
// //               <Switch
// //                 checked={formData.isActive}
// //                 onChange={handleFormChange}
// //                 name="isActive"
// //               />
// //             }
// //             label="Active"
// //           />
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={handleCloseDialog}>Cancel</Button>
// //           <Button variant="contained" onClick={handleSubmit}>
// //             {editingAd ? "Update" : "Create"}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Paper>
// //   );
// // };

// // export default AdManagement;


// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   MenuItem,
//   IconButton,
//   Switch,
//   FormControlLabel,
//   Typography,
// } from "@mui/material";

// import {
//   getAllAds,
//   createAd,
//   updateAd,
//   deleteAd,
// } from "../../../services/adminService";

// import { getCategories } from "../../../services/apiService";

// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";


// // 🔥 EXTRA MANUAL CATEGORIES
// const EXTRA_CATEGORIES = [
//   { _id: "home", name: "Home", slug: "home" },
//   { _id: "article", name: "Article", slug: "article" },
//   { _id: "youth", name: "Youth", slug: "youth" },
// ];

// const AdManagement = () => {
//   const [ads, setAds] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editingAd, setEditingAd] = useState(null);

//   // 🔥 FORM STATE
//   const [formData, setFormData] = useState({
//     type: "google",
//     position: "top",
//     link: "",
//     title: "",
//     mediaType: "",
//     mediaFile: null,
//     isActive: true,

//     // ✅ SINGLE DROPDOWN
//     categories: ["home" , "india"],
//   });

//   const adPositions = [
//     "top",
//     "bottom",
//     "sidebar",
//     "popup",
//     "inline",
//     "inline2",
//     "inlineLarge",
//   ];

//   const adTypes = ["google", "custom"];
//   const customMediaTypes = ["image", "video", "gif"];


//     const AD_SIZE_HINTS = {
//     top: "970 × 250 px",
//     sidebar: "300 × 250 px",
//     bottom: "728 × 90 px",
//     popup: "336 × 280 px",
//     inline:  "728 × 90 px",
//     inline2:  "728 × 90 px",
//     inlineLarge:  "970 × 250 px",
//   };
//   // 🔥 FETCH DATA
//   useEffect(() => {
//     fetchAds();
//     fetchCategories();
//   }, []);

//   const fetchAds = async () => {
//     const res = await getAllAds();
//     setAds(res.ads || []);
//   };

//   const fetchCategories = async () => {
//     try {
//       const res = await getCategories();
//       const apiCategories = res.data || [];

//       // 🔥 MERGE EXTRA + API (no duplicates)
//       const mergedCategories = [
//         ...EXTRA_CATEGORIES,
//         ...apiCategories.filter(
//           (apiCat) =>
//             !EXTRA_CATEGORIES.some(
//               (extra) => extra.name === apiCat.name
//             )
//         ),
//       ];

//       setCategories(mergedCategories);
//     } catch (error) {
//       console.error("Error fetching categories");
//     }
//   };

//   // 🔥 OPEN DIALOG
//   const handleOpenDialog = (ad = null) => {
//     setEditingAd(ad);

//     if (ad) {
//       setFormData({
//         type: ad.type,
//         position: ad.position,
//         link: ad.link || "",
//         title: ad.title || "",
//         mediaType: ad.mediaType || "",
//         mediaFile: null,
//         isActive: ad.isActive,

//         // ✅ EDIT MODE
//         categories: ad.categories || ["home"],
//       });
//     } else {
//       setFormData({
//         type: "google",
//         position: "top",
//         link: "",
//         title: "",
//         mediaType: "",
//         mediaFile: null,
//         isActive: true,

//         // ✅ DEFAULT
//         categories: ["home"],
//       });
//     }

//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setEditingAd(null);
//   };

//   // 🔁 FORM CHANGE
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleFileChange = (e) => {
//     setFormData({ ...formData, mediaFile: e.target.files[0] });
//   };

//   // 🚀 SUBMIT
//   const handleSubmit = async () => {
//     const data = new FormData();

//     data.append("type", formData.type);
//     data.append("position", formData.position);
//     data.append("isActive", formData.isActive);

//     // ✅ SEND CATEGORIES
//     formData.categories.forEach((cat) => {
//       data.append("categories[]", cat);
//     });

//     if (formData.type === "google") {
//       data.append("link", formData.link);
//     } else {
//       data.append("title", formData.title);
//       data.append("mediaType", formData.mediaType);
//       if (formData.mediaFile) data.append("media", formData.mediaFile);
//     }

//     editingAd
//       ? await updateAd(editingAd._id, data)
//       : await createAd(data);

//     fetchAds();
//     handleCloseDialog();
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Delete this ad?")) {
//       await deleteAd(id);
//       fetchAds();
//     }
//   };

//   return (
//     <Paper sx={{ p: 2 }}>
//       <Typography variant="h5">Ad Management</Typography>

//       <Button sx={{ mt: 2 }} variant="contained" onClick={() => handleOpenDialog()}>
//         Add New Ad
//       </Button>

//       {/* TABLE */}
//       <TableContainer sx={{ mt: 2 }}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>#</TableCell>
//               <TableCell>Type</TableCell>
//               <TableCell>Position</TableCell>
//               <TableCell>Categories</TableCell>
//                 <TableCell>Media</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {ads.map((ad, i) => (
//               <TableRow key={ad._id}>
//                 <TableCell>{i + 1}</TableCell>
//                 <TableCell>{ad.type}</TableCell>
//                 <TableCell>{ad.position}</TableCell>
//                 <TableCell>{ad.categories?.join(", ")}</TableCell>
//                           <TableCell>
//                {ad.mediaUrl ? (
//                     ad.mediaType === "video" ? (
//                       <video src={ad.mediaUrl} width="60" />
//                     ) : (
//                       <img src={ad.mediaUrl} width="60" />
//                     )
//                   ) : (
//                     "—"
//                   )}      
//                            </TableCell>
//                 <TableCell>
//                   {ad.isActive ? (
//                     <CheckCircleIcon color="success" />
//                   ) : (
//                     <CancelIcon color="error" />
//                   )}
//                 </TableCell>
//                 <TableCell>
//                   <IconButton onClick={() => handleOpenDialog(ad)}>
//                     <EditIcon />
//                   </IconButton>
//                   <IconButton color="error" onClick={() => handleDelete(ad._id)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* DIALOG */}
//       <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
//         <DialogTitle>
//           {editingAd ? "Edit Ad" : "Add Ad"}
//           <IconButton
//             onClick={handleCloseDialog}
//             sx={{ position: "absolute", right: 8, top: 8 }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           <TextField
//             label="Ad Type"
//             name="type"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.type}
//             onChange={handleChange}
//           >
//             {adTypes.map((t) => (
//               <MenuItem key={t} value={t}>
//                 {t}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="Position"
//             name="position"
//             select
//             fullWidth
//             margin="dense"
//             value={formData.position}
//             onChange={handleChange}
//           >
//             {adPositions.map((p) => (
//               <MenuItem key={p} value={p}>
//                 {p}
//               </MenuItem>
//             ))}
//           </TextField>

//           {/* 🔥 SINGLE CATEGORY DROPDOWN */}
//           <TextField
//             label="Select Pages"
//             select
//             fullWidth
//             margin="dense"
//             SelectProps={{ multiple: true }}
//             value={formData.categories}
//             onChange={(e) =>
//               setFormData({ ...formData, categories: e.target.value })
//             }
//           >
//             {categories.map((cat) => (
//               <MenuItem key={cat._id} value={cat.name}>
//                 {cat.name}
//               </MenuItem>
//             ))}
//           </TextField>

//           {formData.type === "google" && (
//             <TextField
//               label="Google Ad Code"
//               name="link"
//               fullWidth
//               margin="dense"
//               value={formData.link}
//               onChange={handleChange}
//             />
//           )}

//           {formData.type === "custom" && (
//             <>
//               <TextField
//                 label="Title"
//                 name="title"
//                 fullWidth
//                 margin="dense"
//                 value={formData.title}
//                 onChange={handleChange}
//               />
//                {AD_SIZE_HINTS[formData.position] && (
//                 <Typography variant="caption" color="error">
//                   Recommended Size: {AD_SIZE_HINTS[formData.position]}
//                 </Typography>
//               )}
//               <TextField
//                 label="Media Type"
//                 name="mediaType"
//                 select
//                 fullWidth
//                 margin="dense"
//                 value={formData.mediaType}
//                 onChange={handleChange}
//               >
//                 {customMediaTypes.map((m) => (
//                   <MenuItem key={m} value={m}>
//                     {m}
//                   </MenuItem>
//                 ))}
//               </TextField>

         

//               <input type="file" onChange={handleFileChange} />
//             </>
//           )}

//           <FormControlLabel
//             control={
//               <Switch
//                 checked={formData.isActive}
//                 onChange={handleChange}
//                 name="isActive"
//               />
//             }
//             label="Active"
//           />
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleCloseDialog}>Cancel</Button>
//           <Button variant="contained" onClick={handleSubmit}>
//             {editingAd ? "Update" : "Create"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Paper>
//   );
// };

// export default AdManagement;

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  IconButton,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  Chip,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";

import {
  getAllAds,
  createAd,
  updateAd,
  deleteAd,
} from "../../../services/adminService";

import { getCategories } from "../../../services/apiService";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

// मैन्युअल कैटेगरीज
const EXTRA_CATEGORIES = [
  { name: "Home", },
    {name: "India",},


];

const AdManagement = () => {
  const [ads, setAds] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingAd, setEditingAd] = useState(null);

  const [formData, setFormData] = useState({
    type: "google",
    position: "top",
    link: "",
    title: "",
    mediaType: "image",
    mediaFile: null,
    isActive: true,
    categories: ["home"], // डिफ़ॉल्ट ऐरे
  });

  const adPositions = ["top", "bottom", "sidebar", "popup", "inline", "inline2", "inlineLarge"];
  const adTypes = ["google", "custom"];
  const customMediaTypes = ["image", "video", "gif"];

  const AD_SIZE_HINTS = {
    top: "728 × 90 px",
    sidebar: "300 × 250 px",
    bottom: "970 × 250 px",
    popup: "336 × 280 px",
    inline: "728 × 90 px",
    inline2: "728 × 90 px",
    inlineLarge: "970 × 250 px",
  };

  useEffect(() => {
    fetchAds();
    fetchCategories();
  }, []);

  const fetchAds = async () => {
    try {
      const res = await getAllAds();
      setAds(res.ads || []);
    } catch (error) {
      console.error("Error fetching ads", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await getCategories();
      const apiCategories = res.data || [];

      // Extra और API Categories को मिलाना (नाम के आधार पर डुप्लीकेट हटाना)
      const merged = [...EXTRA_CATEGORIES];
      apiCategories.forEach((apiCat) => {
        if (!merged.find((m) => m.name.toLowerCase() === apiCat.name.toLowerCase())) {
          merged.push(apiCat);
        }
      });
      setCategories(merged);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const handleOpenDialog = (ad = null) => {
    if (ad) {
      setEditingAd(ad);
      setFormData({
        type: ad.type || "google",
        position: ad.position || "top",
        link: ad.link || "",
        title: ad.title || "",
        mediaType: ad.mediaType || "image",
        mediaFile: null,
        isActive: ad.isActive ?? true,
        categories: Array.isArray(ad.categories) ? ad.categories : ["home"],
      });
    } else {
      setEditingAd(null);
      setFormData({
        type: "google",
        position: "top",
        link: "",
        title: "",
        mediaType: "image",
        mediaFile: null,
        isActive: true,
        categories: ["home"],
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingAd(null);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCategoryChange = (event) => {
    const { value } = event.target;
    // MUI multiple select value को array के रूप में देता है
    setFormData((prev) => ({
      ...prev,
      categories: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, mediaFile: e.target.files[0] }));
  };

  const handleSubmit = async () => {
    const data = new FormData();
    data.append("type", formData.type);
    data.append("position", formData.position);
    data.append("isActive", formData.isActive);

    // श्रेणियाँ (Categories) भेजना
    if (formData.categories.length > 0) {
      formData.categories.forEach((cat) => {
        data.append("categories[]", cat);
      });
    } else {
      data.append("categories[]", "home");
    }

    if (formData.type === "google") {
      data.append("link", formData.link);
    } else {
      data.append("title", formData.title);
      data.append("mediaType", formData.mediaType);
      if (formData.mediaFile) {
        data.append("media", formData.mediaFile);
      }
    }

    try {
      if (editingAd) {
        await updateAd(editingAd._id, data);
      } else {
        await createAd(data);
      }
      fetchAds();
      handleCloseDialog();
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this ad?")) {
      await deleteAd(id);
      fetchAds();
    }
  };

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Ad Management</Typography>
        <Button variant="contained" color="primary" onClick={() => handleOpenDialog()}>
          + Add New Ad
        </Button>
      </Box>

      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Position</TableCell>
              <TableCell>Pages / Categories</TableCell>
              <TableCell>Media</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ads.map((ad, i) => (
              <TableRow key={ad._id} hover>
                <TableCell>{i + 1}</TableCell>
                <TableCell><Chip label={ad.type} size="small" variant="outlined" /></TableCell>
                <TableCell>{ad.position}</TableCell>
                <TableCell>
                  {ad.categories?.map((c) => (
                    <Chip key={c} label={c} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                  ))}
                </TableCell>
                <TableCell>
               {ad.mediaUrl ? (
  ad.mediaType === "video" ? (
    <video
      src={ad.mediaUrl}
      width="60"
      autoPlay
      loop
      muted
      playsInline
      style={{ borderRadius: "4px" }}
    />
  ) : ad.mediaType === "gif" ? (
    <img
      src={ad.mediaUrl}
      width="60"
      alt="ad-gif"
      style={{ borderRadius: "4px" }}
    />
  ) : (
    <img
      src={ad.mediaUrl}
      width="60"
      alt="ad-img"
      style={{ borderRadius: "4px" }}
    />
  )
) : (
  "No Media"
)}

                </TableCell>
                <TableCell>
                  {ad.isActive ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                </TableCell>
                <TableCell align="right">
                  <IconButton color="primary" onClick={() => handleOpenDialog(ad)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(ad._id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* CREATE/EDIT DIALOG */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          {editingAd ? "Edit Advertisement" : "Create New Ad"}
          <IconButton onClick={handleCloseDialog} sx={{ position: "absolute", right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Ad Type"
              name="type"
              select
              fullWidth
              value={formData.type}
              onChange={handleChange}
            >
              {adTypes.map((t) => <MenuItem key={t} value={t}>{t.toUpperCase()}</MenuItem>)}
            </TextField>

            <TextField
              label="Position"
              name="position"
              select
              fullWidth
              value={formData.position}
              onChange={handleChange}
            >
              {adPositions.map((p) => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </TextField>

            {/* MULTIPLE CATEGORIES DROPDOWN */}
            <FormControl fullWidth>
              <InputLabel>Select Pages (Categories)</InputLabel>
              <Select
                multiple
                value={formData.categories}
                onChange={handleCategoryChange}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
              >
                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat.name}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {formData.type === "google" ? (
              <TextField
                label="Google Ad Code / Link"
                name="link"
                fullWidth
                multiline
                rows={3}
                value={formData.link}
                onChange={handleChange}
              />
            ) : (
              <>
                <TextField
                  label="Ad Title"
                  name="title"
                  fullWidth
                  value={formData.title}
                  onChange={handleChange}
                />
                
                {AD_SIZE_HINTS[formData.position] && (
                  <Typography variant="caption" color="error" sx={{ mt: -1 }}>
                    * Recommended Size: {AD_SIZE_HINTS[formData.position]}
                  </Typography>
                )}

                <TextField
                  label="Media Type"
                  name="mediaType"
                  select
                  fullWidth
                  value={formData.mediaType}
                  onChange={handleChange}
                >
                  {customMediaTypes.map((m) => <MenuItem key={m} value={m}>{m.toUpperCase()}</MenuItem>)}
                </TextField>

                  {editingAd?.mediaUrl && (
  <Box>
    <Typography variant="caption">Current Media:</Typography>

    {editingAd.mediaType === "video" ? (
      <video
        src={editingAd.mediaUrl}
        width={160}
        autoPlay
        loop
        muted
        playsInline
        style={{ borderRadius: "6px" }}
      />
    ) : (
      <img
        src={editingAd.mediaUrl}
        width={160}
        alt="current-ad"
        style={{ borderRadius: "6px" }}
      />
    )}
  </Box>
)}

                
                <Box>

                  
                   <Typography variant="body2" mb={1}>Upload Media File:</Typography>
                   <input type="file" onChange={handleFileChange} accept={
  formData.mediaType === "video"
    ? "video/*"
    : formData.mediaType === "gif"
    ? "image/gif"
    : "image/*"
}
 />
                </Box>
              </>
            )}

            <FormControlLabel
              control={<Switch checked={formData.isActive} onChange={handleChange} name="isActive" color="primary" />}
              label="Status (Active/Inactive)"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseDialog} color="inherit">Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} color="primary">
            {editingAd ? "Update Ad" : "Create Ad"}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdManagement;